import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessage = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.25 27.8592C15.0781 27.8592 16.625 29.4051 16.625 31.2321V32.3564L21.6875 28.5618C22.25 28.1402 22.9531 27.8592 23.7266 27.8592H33.5C34.0625 27.8592 34.625 27.3673 34.625 26.7348V6.49724C34.625 5.93509 34.0625 5.37293 33.5 5.37293H6.5C5.86719 5.37293 5.375 5.93509 5.375 6.49724V26.7348C5.375 27.3673 5.86719 27.8592 6.5 27.8592H13.25ZM16.625 36.5726L16.5547 36.6428L16.2031 36.8536L15.0078 37.7671C14.6562 38.0482 14.2344 38.0482 13.8125 37.9077C13.4609 37.6969 13.25 37.3455 13.25 36.8536V35.378V34.9564V34.8861V34.605V31.2321H9.875H6.5C3.96875 31.2321 2 29.2645 2 26.7348V6.49724C2 4.03781 3.96875 2 6.5 2H33.5C35.9609 2 38 4.03781 38 6.49724V26.7348C38 29.2645 35.9609 31.2321 33.5 31.2321H23.7266L16.625 36.5726Z" })
});
export default SvgMessage;
